import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  AppBar,
  Tabs,
  Tab,
  IconButton,
  TextField,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';

import Button from '../Button'
import ProviderSearchBar from '../ProviderSearchBar'
import TabPanel from '../TabPanel';

function ReviewEditModal(props) {
  const {
    open,
    review,
    save,
    onClose,
    classes: {
      modal,
      modalContent,
      actions,
      input,
      selectInput,
    }
  } = props;

  const [providerId, setProviderId] = useState(review.providerId || '')
  const [rating, setRating] = useState(review.rating || 5)
  const [description, setDescription] = useState(review.description || '')
  const [validationErrors, setValidationErrors] = useState({})

  const onProviderChange = provider => {
    if (provider) {
      setProviderId(provider.id)
      setValidationErrors({ ...validationErrors, provider: false })
    }
  };

  const onSave = () => {
    save({
      id: review.id,
      providerId,
      rating,
      description,
    });
  };

  const validate = () => {
    let valid = true
    let nextState = {}
    if (!providerId) {
      nextState.provider = 'You must select a provider'
      valid = false
    }
    if (!rating) {
      nextState.rating = 'Required'
      valid = false
    } else if (rating > 5 || rating < 1) {
      nextState.rating = 'Rating must be 1 - 5'
      valid = false
    }
    setValidationErrors(nextState)
    return valid
  }

  const renderProvider = () => review.providerName ? (
    <TextField
      inputProps={{
        disabled: true
      }}
      label="Patient"
      variant="filled"
      fullWidth
      value={review.providerName}
      className={selectInput}
    />
  ): (
    <ProviderSearchBar
      clearable={false}
      label="Provider"
      name="Provider"
      placeholder="Search for a provider..."
      errorMessage={validationErrors.provider}
      onSelect={onProviderChange}
      className={selectInput}
    />
  )

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={onClose}
      classes={{ paper: modal }}
    >
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <h2>Review</h2>
          </Grid>

          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent classes={{ root: modalContent }}>
        <AppBar position="static" color="default">
          <Tabs value={0}>
            <Tab label="Review" />
          </Tabs>
        </AppBar>

        <TabPanel>
          <DialogContent>
              {renderProvider()}

            <TextField
              fullWidth
              variant="outlined"
              label="Rating"
              type="number"
              name="rating"
              inputProps={{ min: 1, max: 5 }}
              value={rating}
              onChange={event => {
                setRating(event.target.value)
                setValidationErrors({ ...validationErrors, [event.target.name]: false })
              }}
              error={validationErrors.rating}
              helperText={validationErrors.rating}
              className={input}
            />

            <TextField
              fullWidth
              multiline
              variant="outlined"
              label="Description (Optional)"
              type="text"
              rows="3"
              value={description}
              onChange={event => {
                setDescription(event.target.value)
              }}
              className={input}
            />
          </DialogContent>

          <Grid
            container
            justifyContent="flex-end"
            classes={{ container: actions }}
          >
            <Grid item xs={12} lg={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                onClick={onSave}
                onClickValidation={validate}
              >
                Save Review
              </Button>
            </Grid>
          </Grid>
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
}

ReviewEditModal.propTypes = {
  review: PropTypes.object,
  open: PropTypes.bool.isRequired,
  save: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
  },
  actions: {
    marginTop: '1em',
  },
  input: {
    margin: '0.5em 0',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
});

export default withStyles(styles)(ReviewEditModal);
